import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { inModalLayer, useModalDialog } from 'reusable/useModalDialog';

interface ErrorPopupProps {
  title: string;
  messages: string[];
  onClose: () => void;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ title, messages, onClose }) => {
  const { t } = useTranslation('common');
  // ADM-16。名前（見出し）・Escape・フォーカスの閉じ込めと戻し。
  const titleId = useId();
  const dialogRef = useModalDialog(true, onClose);
  return inModalLayer(
    // ADM-24。追加・編集・削除のダイアログ（z-10 / z-20）より前面に出す。
    <div
      className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-500 bg-opacity-50"
    >
      <div
        className="relative flex flex-col bg-white p-5 rounded shadow-md w-1/3 gap-4"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={dialogRef}
        tabIndex={-1}
      >
        {/* Close button in the top-right corner */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-2 right-4 text-gray-600 hover:text-gray-900"
          // 下の「閉じる」と同じ操作。読み上げとキーボードでは下のボタン（と Escape）を使う。
          aria-hidden="true"
          tabIndex={-1}
        >
          ✕
        </button>

        <h2 id={titleId} className="text-title font-bold mb-4">{title}</h2>
        <ul className="list-none list-inside">
          {messages.map((message, index) => (
            <li key={index} className="text-gray-600">{message}</li>
          ))}
        </ul>
        <button
          type="button"
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          {t('ui.close', { ns: 'common' })}
        </button>
      </div>
    </div>
  );
};

export default ErrorPopup;